"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var spec_1 = require("./spec");
exports.constrain = spec_1.constrain;
exports.optional = spec_1.optional;
exports.either = spec_1.either;
exports.adjust = spec_1.adjust;
exports.alias = spec_1.alias;
exports.definitionOf = spec_1.definitionOf;
exports.extractAliases = spec_1.extractAliases;
exports.verify = spec_1.verify;
var validation_error_1 = require("./validation_error");
exports.ValidationError = validation_error_1.ValidationError;
var type_1 = require("./type");
exports.Type = type_1.Type;
var constraint_1 = require("./constraint");
exports.Constraint = constraint_1.Constraint;
//# sourceMappingURL=index.js.map